import { ChainId } from '@pancakeswap/sdk'
import { useNetworkConnectorUpdater } from 'hooks/useActiveWeb3React'
import { useSwitchNetwork } from 'hooks/useSwitchNetwork'
import styled from 'styled-components'
import { useAccount, useNetwork } from 'wagmi'

/**
 * CADINU runs on BNB Chain only (Bez, 2026-10-03): the header has no network dropdown. This shows only while a connected
 * wallet is on another chain: one button that asks the wallet to switch to BNB Chain. Icon only below 1500 px (the label is
 * its aria-label and title), "Switch to BNB Chain" from 1500 px. Otherwise it renders nothing.
 */
const Btn = styled.button`
  all: unset;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  min-width: 44px;
  justify-content: center;
  padding: 0 10px;
  margin-right: 8px;
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  font-weight: 700;
  font-size: 14px;
  color: #ffd27a;
  background: rgba(246, 196, 83, 0.12);
  border: 1px solid rgba(246, 196, 83, 0.55);
  &:focus-visible {
    outline: 2px solid #7fd4e8;
    outline-offset: 2px;
  }
  &[aria-busy='true'] {
    opacity: 0.7;
  }
  .label {
    display: none;
  }
  @media screen and (min-width: 1500px) {
    .label {
      display: inline;
    }
  }
`

export default function WrongNetworkPill() {
  useNetworkConnectorUpdater() // keeps the page's chain in step with the wallet, as the old switcher did
  const { isConnected } = useAccount()
  const { chain } = useNetwork()
  const { switchNetworkAsync, isLoading } = useSwitchNetwork()
  if (!isConnected || !chain || chain.id === ChainId.BSC) return null
  return (
    <Btn
      type="button"
      data-testid="wrong-network"
      aria-busy={isLoading}
      aria-label="Wrong network: switch to BNB Chain"
      title="Wrong network: switch to BNB Chain"
      onClick={() => switchNetworkAsync(ChainId.BSC)}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 2 1 21h22L12 2Zm0 6 .01 0L12 14h-.01L12 8Zm0 8.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" />
      </svg>
      <span className="label">Switch to BNB Chain</span>
    </Btn>
  )
}
